import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'projectListingsThumbnails',
  standalone: true
})
export class ProjectListingsThumbnailsPipe implements PipeTransform {

	transform(project: any, sliceIndex: number): string[] {
		if (!project?.cartItems?.length) {
			return [];
		}

		const uniqueListingItems: string[] = project.cartItems
			.filter(
				(item: any, index: number, self: any[]) =>
					index === self.findIndex((i: any) =>
						i?.['metadata']?.listingId === item?.['metadata']?.listingId
					)
			)
			.map((item: any) => {
				return item?.['creativeUnitListingThumbnail']?.assetPath || item?.metadata?.['thumbnail']?.assetPath
			});

		return Array.from(uniqueListingItems).slice(0, sliceIndex);
	}

}
